import { render, staticRenderFns } from "./TrainingCustomFieldsForm.vue?vue&type=template&id=6b8b71e6&"
import script from "./TrainingCustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./TrainingCustomFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports